import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=72dc15cc&scoped=true&"
import script from "./Gateway.vue?vue&type=script&lang=js&"
export * from "./Gateway.vue?vue&type=script&lang=js&"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=72dc15cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc15cc",
  null
  
)

export default component.exports